var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundabout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 357,
    viewBox: "0 0 1440 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M777.278 117.473V157.409",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.732 156.825L777.278 141.629L787.019 156.629",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.825 175.819H767.831V170.559H786.825V175.819Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.084 171.436H762.57V156.24H792.084V171.436Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.941 309.164H758.577V174.357H774.941V309.164Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.98 309.164H779.616V174.357H795.98V309.164Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.46 309.164H769.097V174.357H785.46V309.164Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.395 298.577C749.395 298.577 749.395 293.355 748.725 287.729C748.056 282.107 747.787 276.615 750.064 273.668C752.341 270.721 754.483 269.784 752.743 267.776C751.001 265.768 748.457 269.115 748.457 269.115C748.457 269.115 747.52 267.24 747.654 263.223C747.654 263.223 739.975 262.911 739.172 256.483C738.369 250.053 742.832 246.304 742.832 246.304C742.832 246.304 739.529 242.108 733.28 242.197C727.03 242.287 725.155 246.483 725.155 246.483L727.209 246.216C727.209 246.216 721.227 251.483 723.37 258.892L724.798 258C724.798 258 725.334 265.231 722.744 269.16L724.62 268.535C724.62 268.535 724.084 274.695 722.744 278.803L724.798 278.177C724.798 278.177 723.637 293.889 726.316 298.801L749.395 298.577Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.832 246.304C742.832 246.304 745.443 246.616 746.113 249.496C746.113 249.496 750.532 249.764 751.269 250.165C752.006 250.567 751.871 253.045 750.934 254.652C749.997 256.26 749.461 256.26 749.461 256.26L749.394 257.264L748.858 256.26C748.858 256.26 746.849 256.26 746.18 255.323C746.18 255.323 743.769 255.323 743.903 257.397C744.037 259.473 746.247 259.405 747.05 259.273L747.72 258.536L748.055 259.808C748.055 259.808 749.126 259.941 749.126 261.013C749.126 262.084 748.858 262.955 747.653 263.223C746.448 263.491 740.332 262.464 739.172 256.483C738.011 250.5 742.832 246.304 742.832 246.304Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.273 297.193H732.027C726.016 297.193 720.8 301.856 719.44 308.443H758.367L756.663 304.865C754.414 300.143 750.037 297.193 745.273 297.193Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.45 309.044H1324.96V279.735H1462.45V309.044Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.34 276.92H1340.47V260.109H1342.34V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.1 276.92H1349.24V260.109H1351.1V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.91 276.92H1364.75V260.109H1367.91V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.72 276.92H1380.56V260.109H1383.72V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.56 276.92H1403.4V260.109H1406.56V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.8 276.92H1419.63V260.109H1422.8V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.31 276.92H1435.15V260.109H1438.31V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1448.22 257.812H1339.18L1331.71 252.208H1455.7L1448.22 257.812Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.74 252.064H1349.67V237.985H1437.74V252.064Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.9 249.767H1352.25V242.152H1366.9V249.767Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.96 249.767H1369.32V242.152H1383.96V249.767Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1401.03 249.767H1386.38V242.152H1401.03V249.767Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.09 249.767H1403.44V242.152H1418.09V249.767Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.15 249.767H1420.5V242.152H1435.15V249.767Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.13 236.547L1446 236.404C1446 236.404 1429.76 234.68 1425.45 230.944C1421.14 227.209 1421.43 221.032 1421.43 221.032H1419.99C1419.99 221.032 1415.96 229.349 1394.28 228.82V228.789C1394.08 228.797 1393.9 228.799 1393.7 228.804C1393.51 228.799 1393.32 228.797 1393.13 228.789L1393.13 228.82C1371.45 229.349 1367.41 221.032 1367.41 221.032H1365.97C1365.97 221.032 1366.26 227.209 1361.95 230.944C1357.64 234.68 1341.41 236.404 1341.41 236.404L1393.27 236.547V236.548H1393.7H1394.13V236.547Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.52 308.829H1339.67V302.687C1339.67 299.413 1342.32 296.76 1345.59 296.76C1348.87 296.76 1351.52 299.413 1351.52 302.687V308.829Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.87 308.829H1360.79V301.532C1360.79 297.644 1363.94 294.493 1367.83 294.493C1371.71 294.493 1374.87 297.644 1374.87 301.532V308.829Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.7 308.829H1445.55V302.687C1445.55 299.413 1442.9 296.76 1439.63 296.76C1436.35 296.76 1433.7 299.413 1433.7 302.687V308.829Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.35 308.829H1424.43V301.532C1424.43 297.644 1421.28 294.493 1417.39 294.493C1413.5 294.493 1410.35 297.644 1410.35 301.532V308.829Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.32 308.829H1383.49V299.067C1383.49 293.865 1387.7 289.648 1392.9 289.648C1398.11 289.648 1402.32 293.865 1402.32 299.067V308.829Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1448.22 261.691H1339.18V257.812H1448.22V261.691Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.45 281.087H1324.96V276.992H1462.45V281.087Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.94 239.852H1339.47V236.404H1447.94V239.852Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.66 220.159C1368.66 218.885 1367.63 217.852 1366.35 217.852C1365.08 217.852 1364.05 218.885 1364.05 220.159C1364.05 221.432 1365.08 222.464 1366.35 222.464C1367.63 222.464 1368.66 221.432 1368.66 220.159Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.24 220.159C1423.24 218.885 1422.21 217.852 1420.93 217.852C1419.66 217.852 1418.63 218.885 1418.63 220.159C1418.63 221.432 1419.66 222.464 1420.93 222.464C1422.21 222.464 1423.24 221.432 1423.24 220.159Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.956 1.00005L880.785 42.4187H885.628L882.956 1.00005Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.136 51.1027H877.277V41.9173H889.136V51.1027Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.983 60.288H870.431C870.431 53.74 875.739 48.4306 882.288 48.4306H884.125C890.675 48.4306 895.983 53.74 895.983 60.288Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.354 307.96H877.062L879.055 87.544H887.36L889.354 307.96Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.752 65.9666V63.4613H901.661V65.9666H864.752ZM900.221 72.4799H866.193V69.9746H900.221V72.4799ZM898.529 78.8053H867.884V76.3013H898.529V78.8053ZM896.713 85.1319H869.7V82.6266H896.713V85.1319ZM860.66 59.6199L868.677 89.6826H897.736L905.753 59.6199H860.66Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.525 166.181H844.993V159.081H857.525V166.181Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.304 159.081H850.215V131.304H852.304V159.081Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.388 177.251H841.131V165.973H861.388V177.251Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.626 204.116H837.894V176.131H864.626V204.116Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.759 237.113H834.762V202.445H867.759V237.113Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.163 213.247H838.259V206.343H845.163V213.247Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.503 213.247H847.599V206.343H854.503V213.247Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.842 213.247H856.938V206.343H863.842V213.247Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.163 222.448H838.259V215.545H845.163V222.448Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.503 222.448H847.599V215.545H854.503V222.448Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.842 222.448H856.938V215.545H863.842V222.448Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.163 231.651H838.259V224.747H845.163V231.651Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.503 231.651H847.599V224.747H854.503V231.651Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.842 231.651H856.938V224.747H863.842V231.651Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.679 262.699L883.552 251.925L898.187 263.011",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.247 253.927H870.306V248.601H897.247V253.927Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.31 308.121H831.21V233.773H871.31V308.121Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.583 172.385H843.271V168.075H847.583V172.385Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.415 172.385H849.104V168.075H853.415V172.385Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.249 172.385H854.937V168.075H859.249V172.385Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.718 185.007H841.393V179.681H846.718V185.007Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.923 185.007H848.597V179.681H853.923V185.007Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.127 185.007H855.802V179.681H861.127V185.007Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.718 192.943H841.393V187.617H846.718V192.943Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.923 192.943H848.597V187.617H853.923V192.943Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.127 192.943H855.802V187.617H861.127V192.943Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.718 200.88H841.393V195.553H846.718V200.88Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.923 200.88H848.597V195.553H853.923V200.88Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.127 200.88H855.802V195.553H861.127V200.88Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.218 247.624H835.962V239.368H844.218V247.624Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.388 247.624H847.131V239.368H855.388V247.624Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.558 247.624H858.302V239.368H866.558V247.624Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.218 258.628H835.962V250.373H844.218V258.628Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.388 258.628H847.131V250.373H855.388V258.628Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.558 258.628H858.302V250.373H866.558V258.628Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.218 269.633H835.962V261.379H844.218V269.633Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.388 269.633H847.131V261.379H855.388V269.633Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.558 269.633H858.302V261.379H866.558V269.633Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.94 166.181H921.471V159.081H908.94V166.181Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.162 159.081H916.25V131.304H914.162V159.081Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.076 177.251H925.335V165.973H905.076V177.251Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.839 204.116H928.571V176.131H901.839V204.116Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.706 237.113H931.705V202.445H898.706V237.113Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.303 213.247H928.205V206.343H921.303V213.247Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.962 213.247H918.866V206.343H911.962V213.247Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.621 213.247H909.525V206.343H902.621V213.247Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.303 222.448H928.205V215.545H921.303V222.448Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.962 222.448H918.866V215.545H911.962V222.448Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.621 222.448H909.525V215.545H902.621V222.448Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.303 231.651H928.205V224.747H921.303V231.651Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.962 231.651H918.866V224.747H911.962V231.651Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.621 231.651H909.525V224.747H902.621V231.651Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.156 308.121H935.255V233.773H895.156V308.121Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.883 172.385H923.193V168.075H918.883V172.385Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.05 172.385H917.362V168.075H913.05V172.385Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.216 172.385H911.528V168.075H907.216V172.385Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.748 185.007H925.073V179.681H919.748V185.007Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.543 185.007H917.868V179.681H912.543V185.007Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.338 185.007H910.663V179.681H905.338V185.007Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.748 192.943H925.073V187.617H919.748V192.943Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.543 192.943H917.868V187.617H912.543V192.943Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.338 192.943H910.663V187.617H905.338V192.943Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.748 200.88H925.073V195.553H919.748V200.88Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.543 200.88H917.868V195.553H912.543V200.88Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.338 200.88H910.663V195.553H905.338V200.88Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.247 247.624H930.503V239.368H922.247V247.624Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.077 247.624H919.333V239.368H911.077V247.624Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.907 247.624H908.163V239.368H899.907V247.624Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.247 258.628H930.503V250.373H922.247V258.628Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.077 258.628H919.333V250.373H911.077V258.628Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.907 258.628H908.163V250.373H899.907V258.628Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.247 269.633H930.503V261.379H922.247V269.633Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.077 269.633H919.333V261.379H911.077V269.633Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.907 269.633H908.163V261.379H899.907V269.633Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.07 243.627C1271.07 217.651 1250.01 196.592 1224.03 196.592C1198.06 196.592 1177 217.651 1177 243.627C1177 269.604 1198.06 290.663 1224.03 290.663C1250.01 290.663 1271.07 269.604 1271.07 243.627Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.97 243.627C1281.97 211.627 1256.03 185.685 1224.03 185.685C1192.03 185.685 1166.09 211.627 1166.09 243.627C1166.09 275.628 1192.03 301.569 1224.03 301.569C1256.03 301.569 1281.97 275.628 1281.97 243.627Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.09 243.627H1281.97",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.03 302.251V185.003",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.96 225.605L1279.1 261.649",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.8 299.343L1242.27 187.911",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.33 209.329L1270.73 277.927",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.33 290.877L1258.74 196.379",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.22 196.573L1257.84 290.68",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.43 277.836L1271.64 209.417",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.5 188.401L1241.57 298.852",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.16 261.368L1279.91 225.885",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.67 185.003C1227.67 182.996 1226.04 181.368 1224.03 181.368C1222.03 181.368 1220.4 182.996 1220.4 185.003C1220.4 187.011 1222.03 188.639 1224.03 188.639C1226.04 188.639 1227.67 187.011 1227.67 185.003Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.67 301.341C1227.67 299.333 1226.04 297.707 1224.03 297.707C1222.03 297.707 1220.4 299.333 1220.4 301.341C1220.4 303.349 1222.03 304.977 1224.03 304.977C1226.04 304.977 1227.67 303.349 1227.67 301.341Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.2 246.808C1284.21 246.808 1285.84 245.18 1285.84 243.172C1285.84 241.164 1284.21 239.537 1282.2 239.537C1280.19 239.537 1278.57 241.164 1278.57 243.172C1278.57 245.18 1280.19 246.808 1282.2 246.808Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.86 246.808C1167.87 246.808 1169.5 245.18 1169.5 243.172C1169.5 241.164 1167.87 239.537 1165.86 239.537C1163.86 239.537 1162.23 241.164 1162.23 243.172C1162.23 245.18 1163.86 246.808 1165.86 246.808Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.44 228.505C1282.35 227.88 1283.39 225.827 1282.76 223.919C1282.14 222.009 1280.08 220.971 1278.17 221.596C1276.27 222.221 1275.23 224.275 1275.85 226.183C1276.48 228.092 1278.53 229.131 1280.44 228.505Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.89 264.749C1171.8 264.124 1172.84 262.069 1172.21 260.163C1171.59 258.255 1169.53 257.215 1167.63 257.84C1165.72 258.465 1164.68 260.519 1165.3 262.428C1165.93 264.335 1167.98 265.375 1169.89 264.749Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.23 264.607C1280.14 265.225 1282.19 264.181 1282.81 262.272C1283.43 260.361 1282.39 258.311 1280.48 257.691C1278.57 257.069 1276.52 258.115 1275.9 260.024C1275.28 261.935 1276.32 263.985 1278.23 264.607Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.59 228.656C1169.5 229.275 1171.55 228.229 1172.17 226.321C1172.79 224.411 1171.74 222.36 1169.83 221.74C1167.93 221.119 1165.87 222.164 1165.25 224.073C1164.63 225.984 1165.68 228.035 1167.59 228.656Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.4 212.196C1275.03 211.025 1275.41 208.753 1274.24 207.123C1273.06 205.492 1270.79 205.119 1269.16 206.289C1267.53 207.461 1267.16 209.732 1268.33 211.364C1269.5 212.995 1271.77 213.368 1273.4 212.196Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.9 280.055C1180.54 278.885 1180.91 276.612 1179.74 274.981C1178.57 273.351 1176.29 272.979 1174.66 274.149C1173.03 275.321 1172.66 277.592 1173.83 279.223C1175 280.853 1177.27 281.225 1178.9 280.055Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.09 198.184C1262.26 196.557 1261.9 194.284 1260.27 193.107C1258.65 191.931 1256.37 192.295 1255.2 193.921C1254.02 195.548 1254.38 197.82 1256.01 198.997C1257.64 200.175 1259.91 199.811 1261.09 198.184Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.87 292.425C1194.05 290.799 1193.68 288.525 1192.06 287.348C1190.43 286.171 1188.16 286.535 1186.98 288.161C1185.8 289.787 1186.17 292.06 1187.79 293.237C1189.42 294.415 1191.69 294.052 1192.87 292.425Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.52 188.996C1246.15 187.088 1245.1 185.036 1243.19 184.413C1241.28 183.791 1239.23 184.833 1238.61 186.743C1237.99 188.652 1239.03 190.704 1240.94 191.327C1242.85 191.948 1244.9 190.905 1245.52 188.996Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.46 299.604C1210.08 297.695 1209.04 295.643 1207.13 295.019C1205.22 294.396 1203.16 295.44 1202.54 297.348C1201.92 299.259 1202.96 301.311 1204.87 301.933C1206.78 302.555 1208.83 301.512 1209.46 299.604Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.48 186.735C1208.86 184.827 1206.81 183.781 1204.9 184.403C1202.99 185.024 1201.95 187.076 1202.57 188.985C1203.19 190.895 1205.24 191.939 1207.15 191.317C1209.06 190.696 1210.11 188.644 1209.48 186.735Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.49 297.36C1244.87 295.451 1242.82 294.407 1240.91 295.028C1239 295.651 1237.96 297.701 1238.58 299.609C1239.2 301.52 1241.25 302.564 1243.16 301.941C1245.07 301.321 1246.12 299.269 1245.49 297.36Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.86 193.929C1191.68 192.303 1189.41 191.94 1187.78 193.116C1186.15 194.295 1185.79 196.567 1186.97 198.193C1188.15 199.82 1190.42 200.183 1192.04 199.005C1193.67 197.828 1194.04 195.555 1192.86 193.929Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.1 288.152C1259.92 286.525 1257.65 286.163 1256.02 287.339C1254.39 288.517 1254.03 290.791 1255.21 292.416C1256.39 294.043 1258.66 294.405 1260.29 293.228C1261.91 292.051 1262.27 289.777 1261.1 288.152Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.89 206.307C1177.26 205.136 1174.99 205.509 1173.82 207.141C1172.65 208.772 1173.02 211.044 1174.65 212.215C1176.28 213.385 1178.55 213.011 1179.73 211.38C1180.9 209.748 1180.52 207.477 1178.89 206.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.41 274.131C1271.78 272.96 1269.51 273.333 1268.34 274.965C1267.17 276.597 1267.54 278.868 1269.17 280.039C1270.81 281.209 1273.08 280.836 1274.25 279.205C1275.42 277.573 1275.04 275.301 1273.41 274.131Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.36 307.621L1228.42 261.096V238.515H1219.9V258.372L1181.04 309.067L1187.9 309.031L1219.9 266.705V310.772H1228.42V269.364L1257.44 307.755L1263.36 307.621Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.25 308.501H928.007V280.783H1092.25V308.501Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.899 308.097H935.247V291.748C935.247 288.807 937.631 286.423 940.572 286.423C943.514 286.423 945.899 288.807 945.899 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.144 308.097H958.492V291.748C958.492 288.807 960.876 286.423 963.818 286.423C966.759 286.423 969.144 288.807 969.144 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.388 308.097H981.736V291.748C981.736 288.807 984.122 286.423 987.063 286.423C990.004 286.423 992.388 288.807 992.388 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.64 308.097H1004.98V291.748C1004.98 288.807 1007.37 286.423 1010.31 286.423C1013.25 286.423 1015.64 288.807 1015.64 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.88 308.097H1028.23V291.748C1028.23 288.807 1030.61 286.423 1033.55 286.423H1033.55C1036.49 286.423 1038.88 288.807 1038.88 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.12 308.097H1051.47V291.748C1051.47 288.807 1053.86 286.423 1056.8 286.423C1059.74 286.423 1062.12 288.807 1062.12 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.37 308.097H1074.72V291.748C1074.72 288.807 1077.1 286.423 1080.04 286.423C1082.98 286.423 1085.37 288.807 1085.37 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.89 278.404H1071.27V264.337H1092.89V278.404Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.49 278.301H1073.49V268.424C1073.49 267.596 1074.16 266.924 1074.99 266.924C1075.82 266.924 1076.49 267.596 1076.49 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.58 278.301H1080.58V268.424C1080.58 267.596 1081.25 266.924 1082.08 266.924C1082.91 266.924 1083.58 267.596 1083.58 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.66 278.301H1087.66V268.424C1087.66 267.596 1088.33 266.924 1089.16 266.924C1089.99 266.924 1090.66 267.596 1090.66 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.94 262.373H1071.22V259.477C1071.22 253.48 1076.08 248.617 1082.08 248.617C1088.08 248.617 1092.94 253.48 1092.94 259.477V262.373Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.85 237.603L1080.81 248.825H1083.34L1081.85 237.603Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.85 265.061H1069.3V262.011H1094.85V265.061Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.17 254.409H1043.55V240.343H1065.17V254.409Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.77 254.307H1045.77V244.429C1045.77 243.601 1046.45 242.929 1047.27 242.929C1048.1 242.929 1048.77 243.601 1048.77 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.86 254.307H1052.86V244.429C1052.86 243.601 1053.53 242.929 1054.36 242.929C1055.19 242.929 1055.86 243.601 1055.86 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.94 254.307H1059.94V244.429C1059.94 243.601 1060.62 242.929 1061.44 242.929C1062.27 242.929 1062.94 243.601 1062.94 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.22 238.379H1043.5V235.483C1043.5 229.484 1048.36 224.621 1054.36 224.621C1060.36 224.621 1065.22 229.484 1065.22 235.483V238.379Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.13 213.607L1053.09 224.829H1055.63L1054.13 213.607Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.13 241.067H1041.59V238.016H1067.13V241.067Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.712 278.404H949.328V264.337H927.712V278.404Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.105 278.301H947.104V268.424C947.104 267.596 946.433 266.924 945.605 266.924C944.776 266.924 944.105 267.596 944.105 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.021 278.301H940.021V268.424C940.021 267.596 939.349 266.924 938.521 266.924C937.693 266.924 937.021 267.596 937.021 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.935 278.301H932.935V268.424C932.935 267.596 932.263 266.924 931.435 266.924C930.607 266.924 929.935 267.596 929.935 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.66 262.373H949.38V259.477C949.38 253.48 944.517 248.617 938.52 248.617C932.523 248.617 927.66 253.48 927.66 259.477V262.373Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.754 237.603L939.787 248.825H937.254L938.754 237.603Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.747 265.061H951.294V262.011H925.747V265.061Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.811 254.409H976.427V240.343H954.811V254.409Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.204 254.307H974.203V244.429C974.203 243.601 973.531 242.929 972.703 242.929C971.875 242.929 971.204 243.601 971.204 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.119 254.307H967.118V244.429C967.118 243.601 966.447 242.929 965.619 242.929C964.79 242.929 964.119 243.601 964.119 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.033 254.307H960.033V244.429C960.033 243.601 959.361 242.929 958.533 242.929C957.705 242.929 957.033 243.601 957.033 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.759 238.379H976.479V235.483C976.479 229.484 971.616 224.621 965.619 224.621C959.621 224.621 954.759 229.484 954.759 235.483V238.379Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.851 213.607L966.885 224.829H964.351L965.851 213.607Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.845 241.067H978.393V238.016H952.845V241.067Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.7 278.716H956.553V256.167H1063.7V278.716Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.653 268.269L967.827 273.096L963 268.269L967.827 263.441L972.653 268.269Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.754 268.269L988.927 273.096L984.098 268.269L988.927 263.441L993.754 268.269Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.85 268.269L1010.03 273.096L1005.2 268.269L1010.03 263.441L1014.85 268.269Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.95 268.269L1031.12 273.096L1026.3 268.269L1031.12 263.441L1035.95 268.269Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.05 268.269L1052.22 273.096L1047.4 268.269L1052.22 263.441L1057.05 268.269Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.37 254.512H984.479V235.068H1035.37V254.512Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.71 255.548H1004.13V244.584C1004.13 241.385 1006.72 238.792 1009.92 238.792C1013.12 238.792 1015.71 241.385 1015.71 244.584V255.548Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.874 210.452H1034.48V230.517H985.874V210.452Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.342 229.977H988.098V222.717C988.098 221.269 989.271 220.095 990.72 220.095C992.168 220.095 993.342 221.269 993.342 222.717V229.977Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.12 229.977H997.879V222.717C997.879 221.269 999.054 220.095 1000.5 220.095C1001.95 220.095 1003.12 221.269 1003.12 222.717V229.977Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.91 229.977H1007.66V222.717C1007.66 221.269 1008.83 220.095 1010.28 220.095C1011.73 220.095 1012.91 221.269 1012.91 222.717V229.977Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.69 229.977H1017.44V222.717C1017.44 221.269 1018.62 220.095 1020.07 220.095C1021.51 220.095 1022.69 221.269 1022.69 222.717V229.977Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.47 229.977H1027.22V222.717C1027.22 221.269 1028.4 220.095 1029.85 220.095C1031.3 220.095 1032.47 221.269 1032.47 222.717V229.977Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.37 186.457C1008.37 186.457 1005.11 189.56 996.94 193.904C988.769 198.248 986.495 205.075 985.927 210.452H1034.54C1034.54 210.452 1033.55 200.833 1027.25 196.697C1020.94 192.559 1016.49 190.387 1012.09 186.457H1008.37Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.4 181.803L1010.13 164.428L1010.96 181.7L1009.4 181.803Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.01 257.409H953.243V254.1H1067.01V257.409Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.39 282.024H923.663V278.301H1096.39V282.024Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.28 174.149C1013.28 172.464 1011.92 171.1 1010.23 171.1C1008.55 171.1 1007.18 172.464 1007.18 174.149C1007.18 175.833 1008.55 177.2 1010.23 177.2C1011.92 177.2 1013.28 175.833 1013.28 174.149Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.44 183.872C1013.44 182.101 1012 180.665 1010.23 180.665C1008.46 180.665 1007.03 182.101 1007.03 183.872C1007.03 185.643 1008.46 187.077 1010.23 187.077C1012 187.077 1013.44 185.643 1013.44 183.872Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.47 236.516H981.375V229.897H1038.47V236.516Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.385 304.065H773.733V299.557H864.385V304.065Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.862 299.475H777.479V272.431H781.862V299.475Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.425 272.805H776.729V270.739H782.425V272.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.827 299.475H856.444V272.431H860.827V299.475Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.391 272.805H855.693V270.739H861.391V272.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.545 299.475H845.164V272.431H849.545V299.475Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.109 272.805H844.412V270.739H850.109V272.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.265 299.475H833.883V272.431H838.265V299.475Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.829 272.805H833.132V270.739H838.829V272.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.984 299.475H822.602V272.431H826.984V299.475Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.548 272.805H821.851V270.739H827.548V272.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.704 299.475H811.321V272.431H815.704V299.475Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.267 272.805H810.569V270.739H816.267V272.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.423 299.475H800.04V272.431H804.423V299.475Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.987 272.805H799.29V270.739H804.987V272.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.143 299.475H788.761V272.431H793.143V299.475Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.706 272.805H788.01V270.739H793.706V272.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.175 270.76H774.943V266.503H863.175V270.76Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.713 266.503H776.404V259.159H861.713V266.503Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.95 254.483L798.233 249.308V251.728L804.076 249.976V247.805L813.843 245.468V247.22H818.183V249.976L822.023 247.805L859.168 257.071H778.992L778.95 254.483Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.058 307.823H770.061V303.315H868.058V307.823Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.3 259.241H774.818V256.821H863.3V259.241Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.308 264.635H779.346V261.327H788.308V264.635Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.374 264.635H793.411V261.327H802.374V264.635Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.439 264.635H807.477V261.327H816.439V264.635Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.505 264.635H821.542V261.327H830.505V264.635Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.57 264.635H835.607V261.327H844.57V264.635Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.635 264.635H849.672V261.327H858.635V264.635Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.98 223.888L1113.54 223.999L1105.89 221.297H1173.83L1165.98 223.888Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.13 236.345H1113.6V223.875H1166.13V236.345Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.57 207.84C1145.1 197.488 1142.48 194.281 1139.89 194.1V194.093C1139.88 194.095 1139.87 194.096 1139.86 194.097C1139.86 194.096 1139.85 194.095 1139.84 194.093V194.1C1137.25 194.281 1134.63 197.488 1127.15 207.84C1119.63 218.259 1107.33 219.416 1107.33 219.416H1139.84H1139.89H1172.4C1172.4 219.416 1160.1 218.259 1152.57 207.84Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.79 195.143H1136.93V191.887H1142.79V195.143Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.78 186.932H1140.95V192.719H1138.78V186.932Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.19 184.399C1143.19 182.56 1141.7 181.071 1139.86 181.071C1138.02 181.071 1136.54 182.56 1136.54 184.399C1136.54 186.236 1138.02 187.727 1139.86 187.727C1141.7 187.727 1143.19 186.236 1143.19 184.399Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.6 236.345L1095.13 244.015H1182.81L1166.13 236.345H1113.6Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.85 245.932L1175.59 249.665H1103.71L1095.13 245.932H1182.85Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.72 262.827H1103.66V249.369H1175.72V262.827Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.44 260.511H1107.14V252.407H1111.44V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.08 260.511H1114.77V252.407H1119.08V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.72 260.511H1122.41V252.407H1126.72V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.35 260.511H1130.05V252.407H1134.35V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.99 260.511H1137.69V252.407H1141.99V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.63 260.511H1145.32V252.407H1149.63V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.26 260.511H1152.96V252.407H1157.26V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.9 260.511H1160.6V252.407H1164.9V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.54 260.511H1168.24V252.407H1172.54V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.66 262.827L1084.71 272.231H1192.51L1175.72 262.827H1103.66Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.51 274.401L1180.79 279.321H1097.01L1084.71 274.401H1192.51Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.79 302.473H1097.01V279.321H1180.79V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.77 302.473H1102.65V291.909C1102.65 289.433 1104.66 287.425 1107.14 287.425H1107.28C1109.76 287.425 1111.77 289.433 1111.77 291.909V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.68 302.473H1118.57V291.909C1118.57 289.433 1120.58 287.425 1123.05 287.425H1123.2C1125.68 287.425 1127.68 289.433 1127.68 291.909V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.6 302.473H1134.48V291.909C1134.48 289.433 1136.49 287.425 1138.97 287.425H1139.12C1141.59 287.425 1143.6 289.433 1143.6 291.909V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.52 302.473H1150.4V291.909C1150.4 289.433 1152.41 287.425 1154.89 287.425H1155.03C1157.51 287.425 1159.52 289.433 1159.52 291.909V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 302.473H1166.32V291.909C1166.32 289.433 1168.33 287.425 1170.8 287.425H1170.95C1173.43 287.425 1175.43 289.433 1175.43 291.909V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.13 308.695H1092.52V302.473H1185.13V308.695Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.51 274.401H1084.71V272.231H1192.51V274.401Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.83 221.731H1105.89V219.127H1173.83V221.731Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.94 234.32H1132.78V220.799H1146.94V234.32Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.85 245.932H1095.13V244.015H1182.85V245.932Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.51 111.805C1409.8 107.777 1405.77 106.257 1402.98 105.775C1403.95 106.751 1405.02 107.385 1405.69 109.004C1406.35 110.603 1406.95 112.284 1407.05 114.141C1407.04 114.607 1407.04 115.085 1406.99 115.544L1406.75 116.876C1406.54 117.757 1406.28 118.649 1405.82 119.487C1404.96 121.151 1403.43 122.64 1401.56 123.208C1399.72 123.78 1397.74 123.749 1396.02 123.016C1395.15 122.676 1394.33 122.181 1393.67 121.461C1393.02 120.749 1392.57 119.916 1392.34 119.013C1391.92 117.195 1392.42 115.381 1393.37 114.015C1392.88 115.6 1392.82 117.3 1393.43 118.653C1393.72 119.321 1394.19 119.929 1394.73 120.353C1395.26 120.779 1395.92 121.113 1396.62 121.291C1398.01 121.684 1399.53 121.633 1400.81 121.121C1402.11 120.645 1403.1 119.632 1403.76 118.388C1404.11 117.777 1404.33 117.069 1404.53 116.356L1404.75 115.247C1404.79 114.884 1404.79 114.532 1404.84 114.173C1404.88 112.709 1404.49 111.184 1404 109.683C1403.98 109.62 1403.96 109.556 1403.93 109.493C1402.93 106.68 1399.73 105.275 1396.97 106.421C1396.9 106.449 1396.87 106.467 1396.87 106.467C1396.87 106.467 1396.5 93.944 1384.17 94.1294C1371.84 94.3134 1369.45 102.047 1369.45 102.047C1369.45 102.047 1365.95 97.812 1359.88 100.021C1353.8 102.231 1353.62 109.228 1353.62 109.228C1350.31 105.177 1340.19 107.755 1341.66 116.593C1342.82 123.54 1349.09 124.799 1351.72 125.02C1351.72 124.431 1351.75 123.839 1351.84 123.253C1352.07 121.769 1352.62 120.301 1353.49 119.035C1354.36 117.768 1355.52 116.68 1356.87 115.992C1357.51 115.58 1358.25 115.385 1358.94 115.135C1359.66 114.939 1360.98 114.705 1362 114.949C1361.37 115.357 1361.19 115.403 1359.5 115.903C1358.92 116.301 1357.43 117.113 1356.92 117.569C1355.82 118.372 1354.48 120.057 1354.08 121.319C1347.5 142.152 1375.67 139.985 1375.15 130.772C1375.15 130.772 1376.81 138.136 1386.19 137.768C1395.58 137.4 1396.32 129.299 1396.32 129.299C1406.81 135.559 1418.95 121.38 1412.51 111.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.88 140.64C1100.71 137.423 1097.5 136.209 1095.26 135.824C1096.04 136.603 1096.9 137.109 1097.43 138.403C1097.96 139.68 1098.44 141.023 1098.52 142.507C1098.51 142.879 1098.51 143.261 1098.47 143.627L1098.28 144.691C1098.11 145.395 1097.9 146.107 1097.54 146.775C1096.85 148.105 1095.62 149.295 1094.13 149.748C1092.66 150.205 1091.08 150.18 1089.71 149.595C1089.02 149.324 1088.35 148.928 1087.83 148.353C1087.31 147.784 1086.95 147.119 1086.77 146.397C1086.43 144.945 1086.83 143.496 1087.59 142.405C1087.2 143.671 1087.15 145.029 1087.64 146.109C1087.87 146.643 1088.24 147.129 1088.68 147.468C1089.1 147.808 1089.63 148.075 1090.19 148.216C1091.3 148.531 1092.51 148.491 1093.53 148.081C1094.57 147.701 1095.36 146.891 1095.89 145.897C1096.17 145.411 1096.35 144.844 1096.5 144.275L1096.68 143.389C1096.71 143.1 1096.71 142.819 1096.75 142.531C1096.78 141.363 1096.47 140.144 1096.08 138.944C1096.06 138.895 1096.05 138.844 1096.03 138.795C1095.22 136.547 1092.67 135.424 1090.47 136.34C1090.41 136.363 1090.38 136.376 1090.38 136.376C1090.38 136.376 1090.09 126.375 1080.24 126.523C1070.39 126.668 1068.48 132.845 1068.48 132.845C1068.48 132.845 1065.69 129.464 1060.84 131.228C1055.99 132.993 1055.84 138.581 1055.84 138.581C1053.2 135.347 1045.11 137.405 1046.29 144.464C1047.21 150.013 1052.22 151.019 1054.32 151.195C1054.32 150.724 1054.35 150.252 1054.42 149.784C1054.6 148.599 1055.04 147.427 1055.74 146.413C1056.43 145.403 1057.36 144.535 1058.44 143.984C1058.95 143.656 1059.54 143.499 1060.09 143.3C1060.66 143.143 1061.72 142.957 1062.54 143.152C1062.03 143.477 1061.88 143.515 1060.54 143.912C1060.07 144.231 1058.89 144.88 1058.48 145.244C1057.59 145.885 1056.53 147.231 1056.21 148.24C1050.95 164.88 1073.45 163.149 1073.04 155.789C1073.04 155.789 1074.36 161.672 1081.86 161.377C1089.36 161.083 1089.94 154.612 1089.94 154.612C1098.32 159.612 1108.02 148.288 1102.88 140.64Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.396 64.1906C832.232 60.9733 829.012 59.76 826.78 59.3733C827.559 60.1533 828.416 60.66 828.948 61.9533C829.474 63.2293 829.956 64.5733 830.032 66.0573C830.027 66.4293 830.022 66.8107 829.984 67.1773L829.798 68.2413C829.623 68.9453 829.416 69.6573 829.053 70.3253C828.361 71.6546 827.14 72.844 825.648 73.2987C824.178 73.756 822.597 73.7307 821.221 73.1453C820.532 72.8733 819.872 72.4787 819.344 71.9027C818.824 71.3347 818.468 70.668 818.284 69.948C817.952 68.496 818.346 67.0466 819.108 65.956C818.716 67.2213 818.665 68.58 819.156 69.66C819.388 70.1933 819.76 70.68 820.195 71.0186C820.619 71.3573 821.141 71.6253 821.704 71.7667C822.815 72.08 824.027 72.0413 825.048 71.632C826.087 71.2507 826.879 70.4413 827.403 69.448C827.687 68.9613 827.864 68.3946 828.02 67.8253L828.196 66.94C828.232 66.6507 828.231 66.3693 828.267 66.0813C828.3 64.912 827.988 63.6933 827.599 62.496C827.582 62.444 827.564 62.3947 827.546 62.344C826.74 60.0973 824.188 58.9746 821.984 59.8906C821.93 59.912 821.902 59.9253 821.902 59.9253C821.902 59.9253 821.607 49.9253 811.76 50.072C801.911 50.2187 800 56.396 800 56.396C800 56.396 797.207 53.0133 792.356 54.7787C787.506 56.544 787.359 62.132 787.359 62.132C784.712 58.896 776.629 60.956 777.805 68.0147C778.729 73.564 783.738 74.5693 785.84 74.7453C785.838 74.2747 785.863 73.8027 785.934 73.3347C786.119 72.1493 786.56 70.976 787.258 69.9653C787.948 68.9533 788.876 68.084 789.955 67.5347C790.464 67.2053 791.055 67.0493 791.61 66.8507C792.18 66.6933 793.235 66.5067 794.053 66.7027C793.551 67.028 793.402 67.064 792.056 67.464C791.591 67.7813 790.403 68.4307 789.992 68.7947C789.111 69.436 788.048 70.7813 787.73 71.7893C782.472 88.4293 804.968 86.6987 804.556 79.3387C804.556 79.3387 805.879 85.2213 813.376 84.928C820.872 84.6346 821.46 78.1627 821.46 78.1627C829.839 83.1627 839.54 71.8386 834.396 64.1906Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.53 122.623C1269.53 122.623 1291.19 138.324 1303.64 169.727H1310.14C1310.14 169.727 1353.99 231.992 1326.92 307.792H1272.24L1269.53 122.623Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.03 134.533V168.644H1295.52C1295.52 168.644 1294.44 155.108 1276.03 134.533Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.31 177.036H1276.03V172.976H1299.31V177.036Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.83 184.345H1276.03V180.284H1302.83V184.345Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.94 191.655H1276.03V187.595H1305.94V191.655Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.43 198.964H1276.03V194.903H1307.43V198.964Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.38 206.273H1276.03V202.213H1308.38V206.273Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.03 213.583H1276.03V209.521H1312.03V213.583Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.9 220.892H1276.03V216.831H1311.9V220.892Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.93 228.201H1276.43V224.141H1313.93V228.201Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.93 235.511H1276.03V231.449H1313.93V235.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.69 242.82H1276.03V238.76H1315.69V242.82Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.69 250.129H1276.03V246.068H1315.69V250.129Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.82 257.439H1276.03V253.379H1315.82V257.439Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.69 264.748H1276.03V260.687H1315.69V264.748Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.93 272.057H1276.03V267.996H1313.93V272.057Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.93 279.367H1276.03V275.305H1313.93V279.367Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.79 286.676H1276.03V282.615H1313.79V286.676Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.03 293.985H1276.03V289.925H1312.03V293.985Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.24 309.416H1266.82V106.38L1272.24 109.628V309.416Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 307.799H1580.33",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.448 309.044H466.956V279.735H604.448V309.044Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.341 276.92H482.473V260.109H484.341V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.931 276.92H587.064V260.109H588.931V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.103 276.92H491.236V260.109H493.103V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.914 276.92H506.754V260.109H509.914V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.717 276.92H522.557V260.109H525.717V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.56 276.92H545.4V260.109H548.56V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.796 276.92H561.635V260.109H564.796V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.312 276.92H577.15V260.109H580.312V276.92Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.224 257.812H481.179L473.708 252.208H597.696L590.224 257.812Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.738 252.064H491.667V237.985H579.738V252.064Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.901 249.767H494.254V242.152H508.901V249.767Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.963 249.767H511.316V242.152H525.963V249.767Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.026 249.767H528.379V242.152H543.026V249.767Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.088 249.767H545.441V242.152H560.088V249.767Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.151 249.767H562.504V242.152H577.151V249.767Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.134 236.547L587.998 236.404C587.998 236.404 571.763 234.68 567.454 230.944C563.145 227.209 563.43 221.032 563.43 221.032H561.994C561.994 221.032 557.958 229.349 536.277 228.82V228.789C536.081 228.797 535.897 228.799 535.703 228.804C535.509 228.799 535.323 228.797 535.127 228.789L535.129 228.82C513.447 229.349 509.411 221.032 509.411 221.032H507.974C507.974 221.032 508.262 227.209 503.951 230.944C499.642 234.68 483.407 236.404 483.407 236.404L535.271 236.547V236.548H535.703H536.134V236.547Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.519 308.829H481.666V302.687C481.666 299.413 484.319 296.76 487.594 296.76C490.866 296.76 493.519 299.413 493.519 302.687V308.829Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.865 308.829H502.785V301.532C502.785 297.644 505.937 294.493 509.825 294.493C513.713 294.493 516.865 297.644 516.865 301.532V308.829Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.699 308.829H587.551V302.687C587.551 299.413 584.898 296.76 581.626 296.76C578.353 296.76 575.699 299.413 575.699 302.687V308.829Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.353 308.829H566.431V301.532C566.431 297.644 563.281 294.493 559.391 294.493C555.505 294.493 552.353 297.644 552.353 301.532V308.829Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.323 308.829H525.485V299.067C525.485 293.865 529.703 289.648 534.904 289.648C540.105 289.648 544.323 293.865 544.323 299.067V308.829Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.224 261.691H481.179V257.812H590.224V261.691Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.448 281.087H466.956V276.992H604.448V281.087Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.938 239.852H481.467V236.404H589.938V239.852Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.658 220.159C510.658 218.885 509.626 217.852 508.353 217.852C507.078 217.852 506.046 218.885 506.046 220.159C506.046 221.432 507.078 222.464 508.353 222.464C509.626 222.464 510.658 221.432 510.658 220.159Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.241 220.159C565.241 218.885 564.208 217.852 562.933 217.852C561.66 217.852 560.628 218.885 560.628 220.159C560.628 221.432 561.66 222.464 562.933 222.464C564.208 222.464 565.241 221.432 565.241 220.159Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9558 1.00005L22.7852 42.4187H27.6278L24.9558 1.00005Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.136 51.1027H19.2773V41.9173H31.136V51.1027Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9827 60.288H12.4307C12.4307 53.74 17.7387 48.4306 24.288 48.4306H26.1253C32.6747 48.4306 37.9827 53.74 37.9827 60.288Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3535 307.96H19.0615L21.0549 87.544H29.3602L31.3535 307.96Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75216 65.9666V63.4613H43.6615V65.9666H6.75216ZM42.2215 72.4799H8.19349V69.9746H42.2215V72.4799ZM40.5295 78.8053H9.88416V76.3013H40.5295V78.8053ZM38.7135 85.1319H11.7002V82.6266H38.7135V85.1319ZM2.66016 59.6199L10.6775 89.6826H39.7361L47.7535 59.6199H2.66016Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.474838 166.181H-13.0068V159.081H-0.474838V166.181Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38818 177.251H-16.8691V165.973H3.38818V177.251Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62555 204.116H-20.1064V176.131H6.62555V204.116Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75905 237.113H-23.2383V202.445H9.75905V237.113Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84248 213.247H-1.06152V206.343H5.84248V213.247Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84248 222.448H-1.06152V215.545H5.84248V222.448Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84248 231.651H-1.06152V224.747H5.84248V231.651Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6787 262.699L25.552 251.925L40.1867 263.011",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.247 253.927H12.3057V248.601H39.247V253.927Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.31 308.121H-26.79V233.773H13.31V308.121Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24854 172.385H-3.06348V168.075H1.24854V172.385Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12708 185.007H-2.19824V179.681H3.12708V185.007Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12708 192.943H-2.19824V187.617H3.12708V192.943Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12708 200.88H-2.19824V195.553H3.12708V200.88Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55775 247.624H0.301758V239.368H8.55775V247.624Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55775 258.628H0.301758V250.373H8.55775V258.628Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55775 269.633H0.301758V261.379H8.55775V269.633Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9404 166.181H63.4711V159.081H50.9404V166.181Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1621 159.081H58.2501V131.304H56.1621V159.081Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0762 177.251H67.3348V165.973H47.0762V177.251Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8389 204.116H70.5709V176.131H43.8389V204.116Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7061 237.113H73.7047V202.445H40.7061V237.113Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3027 213.247H70.2054V206.343H63.3027V213.247Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9619 213.247H60.8659V206.343H53.9619V213.247Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6211 213.247H51.5251V206.343H44.6211V213.247Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3027 222.448H70.2054V215.545H63.3027V222.448Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9619 222.448H60.8659V215.545H53.9619V222.448Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6211 222.448H51.5251V215.545H44.6211V222.448Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3027 231.651H70.2054V224.747H63.3027V231.651Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9619 231.651H60.8659V224.747H53.9619V231.651Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6211 231.651H51.5251V224.747H44.6211V231.651Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1562 308.121H77.2549V233.773H37.1562V308.121Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8828 172.385H65.1935V168.075H60.8828V172.385Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0498 172.385H59.3618V168.075H55.0498V172.385Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2158 172.385H53.5278V168.075H49.2158V172.385Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.748 185.007H67.0734V179.681H61.748V185.007Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.543 185.007H59.8683V179.681H54.543V185.007Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3379 185.007H52.6632V179.681H47.3379V185.007Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.748 192.943H67.0734V187.617H61.748V192.943Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.543 192.943H59.8683V187.617H54.543V192.943Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3379 192.943H52.6632V187.617H47.3379V192.943Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.748 200.88H67.0734V195.553H61.748V200.88Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.543 200.88H59.8683V195.553H54.543V200.88Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3379 200.88H52.6632V195.553H47.3379V200.88Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2471 247.624H72.5031V239.368H64.2471V247.624Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0771 247.624H61.3332V239.368H53.0771V247.624Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9072 247.624H50.1632V239.368H41.9072V247.624Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2471 258.628H72.5031V250.373H64.2471V258.628Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0771 258.628H61.3332V250.373H53.0771V258.628Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9072 258.628H50.1632V250.373H41.9072V258.628Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2471 269.633H72.5031V261.379H64.2471V269.633Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0771 269.633H61.3332V261.379H53.0771V269.633Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9072 269.633H50.1632V261.379H41.9072V269.633Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.832 259.108H682.095V268.847H691.832V259.108ZM691.832 242.196H682.095V251.935H691.832V242.196ZM691.832 225.283H682.095V235.021H691.832V225.283ZM691.832 208.371H682.095V218.107H691.832V208.371ZM708.746 241.684H699.008V251.421H708.746V241.684ZM708.746 191.457H699.008V201.195H708.746V191.457ZM691.832 191.457H682.095V201.195H691.832V191.457ZM708.746 141.231H699.008V150.968H708.746V141.231ZM708.746 174.544H699.008V184.281H708.746V174.544ZM691.832 174.544H682.095V184.281H691.832V174.544ZM691.832 157.631H682.095V167.369H691.832V157.631ZM691.832 140.719H682.095V150.456H691.832V140.719ZM716.946 90.492L676.97 136.617V307.799H716.946V90.492Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.732 124.349V81.0094H693.114V117.911",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.163 80.7533C695.163 77.9226 692.87 75.628 690.039 75.628C687.207 75.628 684.914 77.9226 684.914 80.7533C684.914 83.584 687.207 85.8787 690.039 85.8787C692.87 85.8787 695.163 83.584 695.163 80.7533Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.203 274.741H699.776",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.203 270.321H705.927",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.203 265.9H710.539",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.203 278.841H692.09",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.203 282.94H699.776",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.203 287.041H695.163",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.203 291.141H699.776",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.203 295.241H682.864",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.203 299.341H699.776",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.782 205.271H640.119V201.451H637.415V205.271H633.754V208.279H637.415V216.493H640.119V208.279H643.782V205.271Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.537 236.5H627.927V223.789H649.537V236.5Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.91 233.393H635.978V231.84C635.978 230.203 637.306 228.875 638.943 228.875C640.582 228.875 641.91 230.203 641.91 231.84V233.393Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.821 215.244H647.771C647.771 215.244 654.975 220.329 664.085 217.151C664.085 217.151 660.483 226.261 639.508 226.896C618.535 227.532 613.449 217.151 613.449 217.151C613.449 217.151 625.525 220.116 630.821 215.244Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.872 216.303C613.872 215.601 613.304 215.032 612.602 215.032C611.9 215.032 611.331 215.601 611.331 216.303C611.331 217.005 611.9 217.575 612.602 217.575C613.304 217.575 613.872 217.005 613.872 216.303Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.204 216.303C666.204 215.601 665.635 215.032 664.932 215.032C664.229 215.032 663.66 215.601 663.66 216.303C663.66 217.005 664.229 217.575 664.932 217.575C665.635 217.575 666.204 217.005 666.204 216.303Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.421 267.009H617.343V249.777H660.421V267.009Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.217 261.077H622.285V256.557H628.217V261.077Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.778 261.077H635.846V256.557H641.778V261.077Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.336 261.077H649.404V256.557H655.336V261.077Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.014 235.184H649.807C649.807 235.184 664.518 241.727 679.066 238.208C679.066 238.208 673.355 252.656 640.094 253.663C606.833 254.671 598.769 238.208 598.769 238.208C598.769 238.208 618.897 241.444 628.014 235.184Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.969 237.208C599.969 236.504 599.4 235.936 598.698 235.936C597.996 235.936 597.428 236.504 597.428 237.208C597.428 237.909 597.996 238.479 598.698 238.479C599.4 238.479 599.969 237.909 599.969 237.208Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.107 237.208C680.107 236.504 679.539 235.936 678.835 235.936C678.134 235.936 677.564 236.504 677.564 237.208C677.564 237.909 678.134 238.479 678.835 238.479C679.539 238.479 680.107 237.909 680.107 237.208Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.18 305.285H606.927V281.416H672.18V305.285Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.594 305.145H616.39V299.991C616.39 298 618.002 296.387 619.991 296.387C621.982 296.387 623.594 298 623.594 299.991V305.145Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.163 305.145H653.96V299.991C653.96 298 655.572 296.387 657.561 296.387C659.551 296.387 661.163 298 661.163 299.991V305.145Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.496 305.145H634.044V297.664C634.044 294.777 636.384 292.439 639.271 292.439C642.156 292.439 644.496 294.777 644.496 297.664V305.145Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.972 263.856H661.082C661.082 263.856 673.406 272.553 692.744 267.876C692.744 267.876 685.151 287.08 640.939 288.42C596.727 289.759 586.01 267.876 586.01 267.876C586.01 267.876 605.854 272.177 617.972 263.856Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.306 267.151C586.306 266.448 585.736 265.88 585.034 265.88C584.331 265.88 583.762 266.448 583.762 267.151C583.762 267.852 584.331 268.423 585.034 268.423C585.736 268.423 586.306 267.852 586.306 267.151Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.771 267.151C693.771 266.448 693.203 265.88 692.5 265.88C691.799 265.88 691.229 266.448 691.229 267.151C691.229 267.852 691.799 268.423 692.5 268.423C693.203 268.423 693.771 267.852 693.771 267.151Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.976 314.749H594.558V304.439H682.976V314.749Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.069 243.627C413.069 217.651 392.01 196.592 366.034 196.592C340.055 196.592 318.998 217.651 318.998 243.627C318.998 269.604 340.055 290.663 366.034 290.663C392.01 290.663 413.069 269.604 413.069 243.627Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.975 243.627C423.975 211.627 398.033 185.685 366.033 185.685C334.032 185.685 308.091 211.627 308.091 243.627C308.091 275.628 334.032 301.569 366.033 301.569C398.033 301.569 423.975 275.628 423.975 243.627Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.091 243.627H423.975",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.033 302.251V185.003",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.964 225.605L421.1 261.649",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.799 299.343L384.265 187.911",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.332 209.329L412.732 277.927",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.33 290.877L400.735 196.379",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.221 196.573L399.845 290.68",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.426 277.836L413.64 209.417",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.498 188.401L383.567 298.852",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.157 261.368L421.908 225.885",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.668 185.003C369.668 182.996 368.04 181.368 366.033 181.368C364.025 181.368 362.397 182.996 362.397 185.003C362.397 187.011 364.025 188.639 366.033 188.639C368.04 188.639 369.668 187.011 369.668 185.003Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.668 301.341C369.668 299.333 368.04 297.707 366.033 297.707C364.025 297.707 362.397 299.333 362.397 301.341C362.397 303.349 364.025 304.977 366.033 304.977C368.04 304.977 369.668 303.349 369.668 301.341Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.202 246.808C426.209 246.808 427.837 245.18 427.837 243.172C427.837 241.164 426.209 239.537 424.202 239.537C422.194 239.537 420.566 241.164 420.566 243.172C420.566 245.18 422.194 246.808 424.202 246.808Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.865 246.808C309.873 246.808 311.499 245.18 311.499 243.172C311.499 241.164 309.873 239.537 307.865 239.537C305.857 239.537 304.229 241.164 304.229 243.172C304.229 245.18 305.857 246.808 307.865 246.808Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.438 228.505C424.348 227.88 425.386 225.827 424.761 223.919C424.136 222.009 422.082 220.971 420.174 221.596C418.265 222.221 417.226 224.275 417.852 226.183C418.478 228.092 420.532 229.131 422.438 228.505Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.891 264.749C313.799 264.124 314.839 262.069 314.212 260.163C313.588 258.255 311.534 257.215 309.626 257.84C307.718 258.465 306.678 260.519 307.304 262.428C307.928 264.335 309.983 265.375 311.891 264.749Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.231 264.607C422.142 265.225 424.193 264.181 424.814 262.272C425.433 260.361 424.389 258.311 422.479 257.691C420.57 257.069 418.518 258.115 417.898 260.024C417.277 261.935 418.322 263.985 420.231 264.607Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.587 228.656C311.496 229.275 313.547 228.229 314.168 226.321C314.788 224.411 313.744 222.36 311.834 221.74C309.926 221.119 307.872 222.164 307.254 224.073C306.632 225.984 307.678 228.035 309.587 228.656Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.402 212.196C417.034 211.025 417.406 208.753 416.235 207.123C415.063 205.492 412.792 205.119 411.16 206.289C409.531 207.461 409.156 209.732 410.328 211.364C411.499 212.995 413.771 213.368 415.402 212.196Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.904 280.055C322.536 278.885 322.908 276.612 321.737 274.981C320.565 273.351 318.293 272.979 316.663 274.149C315.032 275.321 314.659 277.592 315.831 279.223C317.001 280.853 319.273 281.225 320.904 280.055Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.085 198.184C404.263 196.557 403.899 194.284 402.272 193.107C400.647 191.931 398.372 192.295 397.196 193.921C396.019 195.548 396.381 197.82 398.009 198.997C399.636 200.175 401.908 199.811 403.085 198.184Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.871 292.425C336.047 290.799 335.683 288.525 334.056 287.348C332.43 286.171 330.156 286.535 328.98 288.161C327.803 289.787 328.166 292.06 329.794 293.237C331.42 294.415 333.692 294.052 334.871 292.425Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.523 188.996C388.146 187.088 387.102 185.036 385.194 184.413C383.284 183.791 381.232 184.833 380.61 186.743C379.987 188.652 381.031 190.704 382.939 191.327C384.848 191.948 386.9 190.905 387.523 188.996Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.455 299.604C352.078 297.695 351.037 295.643 349.126 295.019C347.217 294.396 345.165 295.44 344.542 297.348C343.921 299.259 344.963 301.311 346.873 301.933C348.781 302.555 350.833 301.512 351.455 299.604Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.484 186.735C350.864 184.827 348.812 183.781 346.903 184.403C344.992 185.024 343.95 187.076 344.571 188.985C345.193 190.895 347.244 191.939 349.152 191.317C351.062 190.696 352.106 188.644 351.484 186.735Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.495 297.36C386.872 295.451 384.821 294.407 382.912 295.028C381.003 295.651 379.959 297.701 380.581 299.609C381.203 301.52 383.255 302.564 385.163 301.941C387.072 301.321 388.116 299.269 387.495 297.36Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.858 193.929C333.679 192.303 331.407 191.94 329.781 193.116C328.154 194.295 327.791 196.567 328.969 198.193C330.147 199.82 332.419 200.183 334.045 199.005C335.671 197.828 336.035 195.555 334.858 193.929Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.096 288.152C401.92 286.525 399.647 286.163 398.02 287.339C396.393 288.517 396.031 290.791 397.208 292.416C398.385 294.043 400.659 294.405 402.285 293.228C403.912 292.051 404.275 289.777 403.096 288.152Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.891 206.307C319.26 205.136 316.988 205.509 315.817 207.141C314.648 208.772 315.02 211.044 316.651 212.215C318.283 213.385 320.555 213.011 321.725 211.38C322.896 209.748 322.523 207.477 320.891 206.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.414 274.131C413.782 272.96 411.511 273.333 410.34 274.965C409.17 276.597 409.543 278.868 411.175 280.039C412.806 281.209 415.078 280.836 416.248 279.205C417.419 277.573 417.044 275.301 415.414 274.131Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.356 307.621L370.42 261.096V238.515H361.899V258.372L323.043 309.067L329.903 309.031L361.899 266.705V310.772H370.42V269.364L399.442 307.755L405.356 307.621Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.25 308.501H70.0068V280.783H234.25V308.501Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8991 308.097H77.2471V291.748C77.2471 288.807 79.6311 286.423 82.5724 286.423C85.5137 286.423 87.8991 288.807 87.8991 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.144 308.097H100.492V291.748C100.492 288.807 102.876 286.423 105.818 286.423C108.759 286.423 111.144 288.807 111.144 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.388 308.097H123.736V291.748C123.736 288.807 126.122 286.423 129.063 286.423C132.004 286.423 134.388 288.807 134.388 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.635 308.097H146.983V291.748C146.983 288.807 149.367 286.423 152.309 286.423C155.25 286.423 157.635 288.807 157.635 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.879 308.097H170.227V291.748C170.227 288.807 172.612 286.423 175.552 286.423H175.553C178.493 286.423 180.879 288.807 180.879 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.124 308.097H193.474V291.748C193.474 288.807 195.858 286.423 198.799 286.423C201.74 286.423 204.124 288.807 204.124 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.37 308.097H216.718V291.748C216.718 288.807 219.102 286.423 222.043 286.423C224.984 286.423 227.37 288.807 227.37 291.748V308.097Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.886 278.404H213.27V264.337H234.886V278.404Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.492 278.301H215.492V268.424C215.492 267.596 216.164 266.924 216.992 266.924C217.82 266.924 218.492 267.596 218.492 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.577 278.301H222.577V268.424C222.577 267.596 223.249 266.924 224.077 266.924C224.905 266.924 225.577 267.596 225.577 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.662 278.301H229.663V268.424C229.663 267.596 230.334 266.924 231.162 266.924C231.991 266.924 232.662 267.596 232.662 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.938 262.373H213.218V259.477C213.218 253.48 218.08 248.617 224.078 248.617C230.076 248.617 234.938 253.48 234.938 259.477V262.373Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.845 237.603L222.811 248.825H225.344L223.845 237.603Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.851 265.061H211.305V262.011H236.851V265.061Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.167 254.409H185.551V240.343H207.167V254.409Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.773 254.307H187.773V244.429C187.773 243.601 188.445 242.929 189.273 242.929C190.101 242.929 190.773 243.601 190.773 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.859 254.307H194.86V244.429C194.86 243.601 195.531 242.929 196.359 242.929C197.187 242.929 197.859 243.601 197.859 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.943 254.307H201.944V244.429C201.944 243.601 202.615 242.929 203.444 242.929C204.272 242.929 204.943 243.601 204.943 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.219 238.379H185.499V235.483C185.499 229.484 190.362 224.621 196.359 224.621C202.358 224.621 207.219 229.484 207.219 235.483V238.379Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.126 213.607L195.092 224.829H197.625L196.126 213.607Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.132 241.067H183.587V238.016H209.132V241.067Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7119 278.404H91.3279V264.337H69.7119V278.404Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1055 278.301H89.1041V268.424C89.1041 267.596 88.4335 266.924 87.6055 266.924C86.7761 266.924 86.1055 267.596 86.1055 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0205 278.301H82.0205V268.424C82.0205 267.596 81.3485 266.924 80.5205 266.924C79.6925 266.924 79.0205 267.596 79.0205 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9346 278.301H74.9346V268.424C74.9346 267.596 74.2626 266.924 73.4346 266.924C72.6066 266.924 71.9346 267.596 71.9346 268.424V278.301Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6602 262.373H91.3801V259.477C91.3801 253.48 86.5175 248.617 80.5201 248.617C74.5228 248.617 69.6602 253.48 69.6602 259.477V262.373Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7539 237.603L81.7872 248.825H79.2539L80.7539 237.603Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7471 265.061H93.2937V262.011H67.7471V265.061Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8105 254.409H118.427V240.343H96.8105V254.409Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.204 254.307H116.203V244.429C116.203 243.601 115.531 242.929 114.703 242.929C113.875 242.929 113.204 243.601 113.204 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.119 254.307H109.118V244.429C109.118 243.601 108.447 242.929 107.619 242.929C106.79 242.929 106.119 243.601 106.119 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0332 254.307H102.033V244.429C102.033 243.601 101.361 242.929 100.533 242.929C99.7052 242.929 99.0332 243.601 99.0332 244.429V254.307Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7588 238.379H118.479V235.483C118.479 229.484 113.616 224.621 107.619 224.621C101.621 224.621 96.7588 229.484 96.7588 235.483V238.379Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.851 213.607L108.885 224.829H106.351L107.851 213.607Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8447 241.067H120.393V238.016H94.8447V241.067Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.705 278.716H98.5527V256.167H205.705V278.716Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.653 268.269L109.827 273.096L105 268.269L109.827 263.441L114.653 268.269Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.754 268.269L130.927 273.096L126.098 268.269L130.927 263.441L135.754 268.269Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.853 268.269L152.026 273.096L147.199 268.269L152.026 263.441L156.853 268.269Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.951 268.269L173.125 273.096L168.298 268.269L173.125 263.441L177.951 268.269Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.05 268.269L194.223 273.096L189.396 268.269L194.223 263.441L199.05 268.269Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.365 254.512H126.479V235.068H177.365V254.512Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.714 255.548H146.13V244.584C146.13 241.385 148.723 238.792 151.922 238.792C155.121 238.792 157.714 241.385 157.714 244.584V255.548Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.874 210.452H176.485V230.517H127.874V210.452Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.342 229.977H130.098V222.717C130.098 221.269 131.271 220.095 132.72 220.095C134.168 220.095 135.342 221.269 135.342 222.717V229.977Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.124 229.977H139.879V222.717C139.879 221.269 141.054 220.095 142.502 220.095C143.95 220.095 145.124 221.269 145.124 222.717V229.977Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.905 229.977H149.661V222.717C149.661 221.269 150.834 220.095 152.282 220.095C153.73 220.095 154.905 221.269 154.905 222.717V229.977Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.687 229.977H159.443V222.717C159.443 221.269 160.618 220.095 162.066 220.095C163.514 220.095 164.687 221.269 164.687 222.717V229.977Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.47 229.977H169.225V222.717C169.225 221.269 170.399 220.095 171.847 220.095C173.295 220.095 174.47 221.269 174.47 222.717V229.977Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.371 186.457C150.371 186.457 147.112 189.56 138.94 193.904C130.769 198.248 128.495 205.075 127.927 210.452H176.537C176.537 210.452 175.553 200.833 169.245 196.697C162.936 192.559 158.488 190.387 154.093 186.457H150.371Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.404 181.803L152.128 164.428L152.956 181.7L151.404 181.803Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.014 257.409H95.2432V254.1H209.014V257.409Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.387 282.024H65.6631V278.301H238.387V282.024Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.282 174.149C155.282 172.464 153.918 171.1 152.232 171.1C150.547 171.1 149.182 172.464 149.182 174.149C149.182 175.833 150.547 177.2 152.232 177.2C153.918 177.2 155.282 175.833 155.282 174.149Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.437 183.872C155.437 182.101 154.003 180.665 152.232 180.665C150.461 180.665 149.025 182.101 149.025 183.872C149.025 185.643 150.461 187.077 152.232 187.077C154.003 187.077 155.437 185.643 155.437 183.872Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 236.516H123.375V229.897H180.468V236.516Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38513 304.065H-84.2666V299.557H6.38513V304.065Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.827 299.475H-1.55566V272.431H2.827V299.475Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39069 272.805H-2.30664V270.739H3.39069V272.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17457 270.76H-83.0566V266.503H5.17457V270.76Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71323 266.503H-81.5957V259.159H3.71323V266.503Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-79.0498 254.483L-59.7667 249.308V251.728L-53.9241 249.976V247.805L-44.1574 245.468V247.22H-39.8174V249.976L-35.9774 247.805L1.16794 257.071H-79.0082L-79.0498 254.483Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0577 307.823H-87.9395V303.315H10.0577V307.823Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30036 259.241H-83.1816V256.821H5.30036V259.241Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634554 264.635H-8.32812V261.327H0.634554V264.635Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.983 223.888L255.539 223.999L247.894 221.297H315.83L307.983 223.888Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.125 236.345H255.599V223.875H308.125V236.345Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.571 207.84C287.095 197.488 284.477 194.281 281.887 194.1V194.093C281.879 194.095 281.871 194.096 281.863 194.097C281.855 194.096 281.846 194.095 281.838 194.093V194.1C279.25 194.281 276.631 197.488 269.153 207.84C261.63 218.259 249.33 219.416 249.33 219.416H281.838H281.887H314.395C314.395 219.416 302.095 218.259 294.571 207.84Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.792 195.143H278.931V191.887H284.792V195.143Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.776 186.932H282.947V192.719H280.776V186.932Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.191 184.399C285.191 182.56 283.702 181.071 281.863 181.071C280.024 181.071 278.535 182.56 278.535 184.399C278.535 186.236 280.024 187.727 281.863 187.727C283.702 187.727 285.191 186.236 285.191 184.399Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.599 236.345L237.127 244.015H324.815L308.126 236.345H255.599Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.85 245.932L317.595 249.665H245.706L237.127 245.932H324.85Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.723 262.827H245.663V249.369H317.723V262.827Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.441 260.511H249.137V252.407H253.441V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.079 260.511H256.773V252.407H261.079V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.715 260.511H264.411V252.407H268.715V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.353 260.511H272.048V252.407H276.353V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.99 260.511H279.686V252.407H283.99V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.629 260.511H287.323V252.407H291.629V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.264 260.511H294.96V252.407H299.264V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.903 260.511H302.598V252.407H306.903V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.541 260.511H310.235V252.407H314.541V260.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.663 262.827L226.707 272.231H334.508L317.723 262.827H245.663Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.508 274.401L322.788 279.321H239.007L226.707 274.401H334.508Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.788 302.473H239.007V279.321H322.788V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.765 302.473H244.649V291.909C244.649 289.433 246.657 287.425 249.136 287.425H249.281C251.759 287.425 253.765 289.433 253.765 291.909V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.684 302.473H260.568V291.909C260.568 289.433 262.576 287.425 265.052 287.425H265.199C267.675 287.425 269.684 289.433 269.684 291.909V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.6 302.473H276.484V291.909C276.484 289.433 278.492 287.425 280.97 287.425H281.115C283.594 287.425 285.6 289.433 285.6 291.909V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.517 302.473H292.401V291.909C292.401 289.433 294.409 287.425 296.885 287.425H297.032C299.509 287.425 301.517 289.433 301.517 291.909V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.433 302.473H308.317V291.909C308.317 289.433 310.325 287.425 312.804 287.425H312.949C315.427 287.425 317.433 289.433 317.433 291.909V302.473Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.129 308.695H234.521V302.473H327.129V308.695Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.508 274.401H226.707V272.231H334.508V274.401Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.83 221.731H247.894V219.127H315.83V221.731Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.943 234.32H274.781V220.799H288.943V234.32Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.85 245.932H237.127V244.015H324.85V245.932Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.51 111.805C551.801 107.777 547.771 106.257 544.975 105.775C545.95 106.751 547.025 107.385 547.69 109.004C548.347 110.603 548.953 112.284 549.047 114.141C549.039 114.607 549.035 115.085 548.987 115.544L548.754 116.876C548.537 117.757 548.275 118.649 547.821 119.487C546.955 121.151 545.427 122.64 543.558 123.208C541.717 123.78 539.739 123.749 538.017 123.016C537.153 122.676 536.326 122.181 535.667 121.461C535.015 120.749 534.569 119.916 534.339 119.013C533.922 117.195 534.417 115.381 535.371 114.015C534.879 115.6 534.817 117.3 535.43 118.653C535.721 119.321 536.186 119.929 536.73 120.353C537.262 120.779 537.917 121.113 538.619 121.291C540.011 121.684 541.53 121.633 542.807 121.121C544.106 120.645 545.098 119.632 545.755 118.388C546.111 117.777 546.333 117.069 546.529 116.356L546.75 115.247C546.793 114.884 546.793 114.532 546.837 114.173C546.879 112.709 546.487 111.184 546.001 109.683C545.979 109.62 545.957 109.556 545.933 109.493C544.927 106.68 541.73 105.275 538.971 106.421C538.903 106.449 538.869 106.467 538.869 106.467C538.869 106.467 538.499 93.944 526.169 94.1294C513.839 94.3134 511.447 102.047 511.447 102.047C511.447 102.047 507.95 97.812 501.877 100.021C495.805 102.231 495.621 109.228 495.621 109.228C492.307 105.177 482.186 107.755 483.658 116.593C484.815 123.54 491.087 124.799 493.718 125.02C493.715 124.431 493.749 123.839 493.837 123.253C494.067 121.769 494.621 120.301 495.493 119.035C496.358 117.768 497.519 116.68 498.87 115.992C499.509 115.58 500.249 115.385 500.942 115.135C501.657 114.939 502.978 114.705 504.001 114.949C503.373 115.357 503.186 115.403 501.501 115.903C500.918 116.301 499.431 117.113 498.918 117.569C497.815 118.372 496.483 120.057 496.085 121.319C489.501 142.152 517.667 139.985 517.151 130.772C517.151 130.772 518.809 138.136 528.194 137.768C537.579 137.4 538.317 129.299 538.317 129.299C548.806 135.559 560.951 121.38 554.51 111.805Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.879 140.64C242.715 137.423 239.496 136.209 237.263 135.824C238.041 136.603 238.899 137.109 239.431 138.403C239.956 139.68 240.439 141.023 240.516 142.507C240.509 142.879 240.505 143.261 240.468 143.627L240.281 144.691C240.107 145.395 239.9 146.107 239.537 146.775C238.845 148.105 237.624 149.295 236.132 149.748C234.66 150.205 233.081 150.18 231.705 149.595C231.016 149.324 230.355 148.928 229.828 148.353C229.308 147.784 228.951 147.119 228.767 146.397C228.435 144.945 228.829 143.496 229.592 142.405C229.2 143.671 229.149 145.029 229.64 146.109C229.872 146.643 230.243 147.129 230.677 147.468C231.101 147.808 231.625 148.075 232.187 148.216C233.299 148.531 234.511 148.491 235.531 148.081C236.569 147.701 237.363 146.891 237.885 145.897C238.169 145.411 238.347 144.844 238.504 144.275L238.68 143.389C238.715 143.1 238.713 142.819 238.751 142.531C238.784 141.363 238.472 140.144 238.083 138.944C238.064 138.895 238.047 138.844 238.029 138.795C237.224 136.547 234.671 135.424 232.468 136.34C232.413 136.363 232.384 136.376 232.384 136.376C232.384 136.376 232.091 126.375 222.243 126.523C212.393 126.668 210.483 132.845 210.483 132.845C210.483 132.845 207.691 129.464 202.84 131.228C197.988 132.993 197.841 138.581 197.841 138.581C195.196 135.347 187.112 137.405 188.288 144.464C189.211 150.013 194.221 151.019 196.323 151.195C196.32 150.724 196.347 150.252 196.417 149.784C196.601 148.599 197.043 147.427 197.741 146.413C198.431 145.403 199.36 144.535 200.437 143.984C200.947 143.656 201.539 143.499 202.093 143.3C202.664 143.143 203.717 142.957 204.537 143.152C204.035 143.477 203.884 143.515 202.539 143.912C202.073 144.231 200.887 144.88 200.476 145.244C199.595 145.885 198.532 147.231 198.212 148.24C192.955 164.88 215.452 163.149 215.039 155.789C215.039 155.789 216.363 161.672 223.86 161.377C231.356 161.083 231.944 154.612 231.944 154.612C240.321 159.612 250.024 148.288 244.879 140.64Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.529 122.623C411.529 122.623 433.187 138.324 445.64 169.727H452.136C452.136 169.727 495.992 231.992 468.921 307.792H414.236L411.529 122.623Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.027 134.533V168.644H437.518C437.518 168.644 436.435 155.108 418.027 134.533Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.309 177.036H418.027V172.976H441.309V177.036Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.827 184.345H418.027V180.284H444.827V184.345Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.941 191.655H418.027V187.595H447.941V191.655Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.429 198.964H418.027V194.903H449.429V198.964Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.377 206.273H418.027V202.213H450.377V206.273Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.033 213.583H418.027V209.521H454.033V213.583Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.897 220.892H418.027V216.831H453.897V220.892Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.927 228.201H418.433V224.141H455.927V228.201Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.927 235.511H418.027V231.449H455.927V235.511Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.686 242.82H418.027V238.76H457.686V242.82Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.686 250.129H418.027V246.068H457.686V250.129Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.821 257.439H418.027V253.379H457.821V257.439Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.686 264.748H418.027V260.687H457.686V264.748Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.927 272.057H418.027V267.996H455.927V272.057Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.927 279.367H418.027V275.305H455.927V279.367Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.791 286.676H418.027V282.615H455.791V286.676Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.033 293.985H418.027V289.925H454.033V293.985Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.236 309.416H408.821V106.38L414.236 109.628V309.416Z",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-151 307.799H722.327",
    stroke: "#070C12",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundabout);
export default __webpack_public_path__ + "static/media/backgroundabout.9f9a75332828c0222996bcab1d7635a0.svg";
export { ForwardRef as ReactComponent };